/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import FeatherIcon from "feather-icons-react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { useNavigate } from "react-router-dom";
import {
  FileUpload,
  ItemTemplateOptions,
  FileUploadHandlerEvent,
} from "primereact/fileupload";
import { Toast } from "primereact/toast";
import axios from "../../../../util/axiosconfig";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/zoom/lib/styles/index.css";
import "@react-pdf-viewer/print/lib/styles/index.css";

import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import { Timeline } from "primereact/timeline";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputTextarea } from "primereact/inputtextarea";
import { Dialog } from "primereact/dialog";
import { useDrop } from "react-dnd";
import FileViewer from "./FileViewer";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { ROLES } from "../../../../util/roleNameConstants";
import { Checkbox } from "primereact/checkbox";
import { CATHERINE_O_NEILL, STATUSES } from "../../../../util/constants";
import AddJobNumbers from "./AddJobNumbers";
import { MultiSelect } from "primereact/multiselect";
import { Tooltip } from "primereact/tooltip";
import {
  amountToGBP,
  formatGBP,
  formatGBPForAmountEntry,
} from "../../leak detection/helper/helperFunctions";
import { InputNumber } from "primereact/inputnumber";

interface Status {
  statusID: string; // or number, depending on your API
  displayName: string;
}

interface Supplier {
  userID: any;
  supplierID: any;
  firstName: string;
  lastName: string;
  displayName: string;
  businessNumber: string;
  userEmail: any;
  address: string;
  country: string;
  countryID: number;
  currencySymbol: string;
  currencyCode: string;
  isActive: boolean;
  isEditable: boolean;
}

export interface Currency {
  currencyID: number;
  currencyName: string;
  currencySymbol: string;
  createdDate?: any;
  isActive?: boolean;
}

interface Company {
  companyID: number;
  companyName: string;
  createdDate: Date;
  isActive: boolean;
}

interface User {
  userID: string;
  userEmail: string;
  firstName: string;
  lastName: string;
  displayName: string;
  roleID: number;
  createdDate: Date;
  roleDisplayName: string;
  isActive: boolean;
  isEditable: boolean;
}

interface TimelineEvent {
  poNo?: string;
  date?: any;
  activity?: string;
  statusID?: number;
  userEmail?: string;
  status?: any;
  displayName?: any;
  action?: any;
  comment?: string;
  finalApproval?: boolean;
}

interface Errors {
  supplierID?: string | null;
  invoiceDate?: string | null;
  billNo?: string | null;
  jobNoMapping?: any;
  poNumber?: string | null;
  totalAmount?: any;
  managerID?: string | null;
  seniorManagerID?: string | null;
  directorID?: string | null;
  currencyID?: string | null;
  companyID?: string | null;
  files?: string | null;
  confirmJobNo?: string | null;
  confirmSiteName?: string | null;
  comment?: string | null;
}

const customBase64Uploader = async (event: FileUploadHandlerEvent) => {
  // Get the first file from the uploaded files
  const file = event.files[0];

  // Create an object URL from the file
  const objectURL = URL.createObjectURL(file);

  // Fetch the file's blob
  let blob = await fetch(objectURL).then((r) => r.blob());
  // Revoke the object URL to release memory
  URL.revokeObjectURL(objectURL);
  // Convert the blob to base64 using FileReader
  const reader = new FileReader();

  reader.readAsDataURL(blob);
  reader.onloadend = function () {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const base64data = reader.result;
  };
};

function AddInvoice() {
  const navigate = useNavigate();
  const [uploadedFile, setUploadedFile] = useState<any>(null);
  const [invoiceID, setInvoiceID] = useState<number | null>(null);
  const [isInvoicePresent, setIsInvoicePresent] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [cancelFileOnEdit, setCancelFileOnEdit] = useState<boolean>(false);
  const [isFinalApproval, setIsFinalApproval] = useState<any>(false);

  const [showAddJobNumber, setShowAddJobNumber] = useState<boolean>(false);

  const [tempJobEntries, setTempJobEntries] = useState<any>([
    { jobNumber: "", amount: "" },
  ]);

  const [validationErrors, setValidationErrors] = useState<any[]>([]);
  const [tempValidationErrors, setTempValidationErrors] = useState<any[]>([]);

  const [currency, setCurrency] = useState<Currency[]>([
    {
      currencyID: 1,
      currencyName: "Euro",
      currencySymbol: "€",
      createdDate: "2024-09-23T11:00:26.000Z",
      isActive: true,
    },
    {
      currencyID: 2,
      currencyName: "Pound sterling",
      currencySymbol: "£",
      createdDate: "2024-09-23T11:00:26.000Z",
      isActive: true,
    },
  ]); // State to hold all currency
  const [confirmSiteName, setConfirmSiteName] = useState<string>("");
  const [isConfirmEntryDialogOpen, setIsConfirmEntryDialogOpen] =
    useState<boolean>(false);

  const [isResetForm, setIsResetForm] = useState<boolean>(false);

  const [newTempJobNumbers, setNewTempJobNumbers] = useState<any[]>([]);

  const [isFirstJobNumber, setIsFirstJobNumber] = useState<boolean>(false);
  const [formValues, setFormValues] = useState<any>({
    selectedSupplier: null,
    invoiceDate: null,
    billNo: null,
    selectedCurrency: {
      currencyID: 2,
      currencyName: "Pound sterling",
      currencySymbol: "£",
      createdDate: "2024-09-23T11:00:26.000Z",
      isActive: true,
    },
    totalAmount: null,
    jobNoMapping: [],
    jobNumber: null,
    selectedManager: null,
    selectedSeniorManager: null,
    selectedDirector: null,
    poNumber: null,
    selectedCompany: null,
    commentBySuperAdmin: null,
    commentByManager: null,
    commentBySeniorManager: null,
    commentByDirector: null,
    createdByID: null,
    finalApproval: false,
    firstTimeChange: false,
  });

  const [allProjects, setAllProjects] = useState<any[]>([]);
  const [newAllProjects, setNewAllProjects] = useState<any[]>([]);

  const [originalValues, setOriginalValues] = useState<any>({});
  const [isFormModified, setIsFormModified] = useState<boolean>(false);
  const [confirmJobNo, setConfirmJobNo] = useState<any>([]);
  const [selectedDirectorEmail, setSelectedDirectorEmail] = useState<
    any | null
  >(null);
  const [suppliersListLoading, setSuppliersListLoading] =
    useState<boolean>(false);
  const [formErrors, setFormErrors] = useState<Errors>({});
  const [error, setError] = useState<any | null>(null);
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [managers, setManagers] = useState<User[]>([]); // State to hold all User details
  const [seniorManagers, setSeniorManagers] = useState<User[]>([]); // State to hold Senior Manager details
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [fileUploading, setFileUpLoading] = useState<boolean>(false);
  const [directors, setDirectors] = useState<User[]>([]); // State to hold User data
  const [companies, setCompanies] = useState<Company[]>([]); // State to hold company data
  const [viewFile, setViewFile] = useState<any | null>(null);
  const [isAddInvoice, setIsAddInvoice] = useState<boolean>(false);
  const [files, setFiles] = useState<any>([]); // State to store selected files
  const [statuses, setStatuses] = useState<Status[]>([]);
  const [invoiceDetailsLoading, setInvoiceDetailsLoading] =
    useState<boolean>(false);
  const toast = useRef<Toast>(null);
  const [invoiceActivity, setInvoiceActivity] = useState<any[]>([]);
  const [selectedInvoice, setSelectedInvoice] = useState<any | null>(null);
  const [approveRejectDialog, setApproveRejectDialog] =
    useState<boolean>(false);
  const [commentType, setCommentType] = useState<string>("");
  const [approveRejectComment, setApproveRejectComment] = useState<string>("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [isEntryButtonDisabled, setIsEntryButtonDisabled] =
    useState<boolean>(false);

  const [isApproveRejectButtonDisabled, setIsApproveRejectButtonDisabled] =
    useState<boolean>(false);
  // const page = 0;

  useEffect(() => {
    return () => {
      files.forEach((file: any) => {
        URL.revokeObjectURL(file.objectURL); // Ensure you store objectURL in file
      });
    };
  }, [files]);

  useEffect(() => {
    // && tempJobEntries[0].jobNumber === ""
    if (tempJobEntries.length === 1) {
      setIsFirstJobNumber(true);
    } else if (tempJobEntries.length > 1) {
      setIsFirstJobNumber(false);
    }
  }, [tempJobEntries.length]);

  const handleDrop = (acceptedFiles: any) => {
    setFiles((prevFiles: any) => [...prevFiles, ...acceptedFiles]);
  };

  const [{ isOver }, drop] = useDrop({
    accept: "file",
    drop: (item: any) => {
      handleDrop(item.files);
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });
  const query = new URLSearchParams(window.location.search);
  const invoiceParam = Number(query.get("invoice"));

  const fetchInvoice = async () => {
    try {
      const response = await axios.get(
        `invoice/single-invoice?invoiceID=${invoiceParam}`
      );

      if (response.data.result.length === 0) {
        navigate("/layout/invoice-management");
      }

      const projects = await axios.get(
        "tl-admin/project/all?page=-1&&isActive=true"
      );

      setSelectedInvoice(response.data.result);
      const selectedSupplierArray = {
        supplierID: response.data.result.supplierID,
        displayName: response.data.result.supplierName,
      };
      const selectedManagerArray = {
        userID: response.data.result.managerID,
        displayName: response.data.result.managerName,
      };
      const selectedSeniorManagerArray = {
        userID: response.data.result.seniorManagerID,
        displayName: response.data.result.seniorManagerName,
      };
      const selectedDirectorArray = {
        userID: response.data.result.directorID,
        displayName: response.data.result.directorName,
        userEmail: response.data.result.directorEmail,
      };
      const selectedCurrencyToShow = {
        currencyID: response.data.result.currencyID,
        currencyName: response.data.result.currencyName,
        currencySymbol: response.data.result.currencySymbol,
        createdDate:
          response.data.result.currencyCreatedDate || new Date().toISOString(),
        isActive: response.data.result.isCurrencyActive || true,
      };

      if (!formValues?.firstTimeChange) {
        setSelectedDirectorEmail(response.data.result.directorEmail);
        setIsFinalApproval(response.data.result.finalApproval);
        if (response.data.result.jobNoMapping.length === 1) {
          setTempJobEntries([
            {
              jobNumber: response.data.result.jobNoMapping[0].jobNumber,
              amount: response.data.result.totalAmount,
            },
          ]);
        } else if (response.data.result.jobNoMapping.length === 0) {
          setTempJobEntries([
            {
              jobNumber: projects.data.result.find(
                (project: any) =>
                  project.projectKey.toString() ===
                  response.data.result.jobNumber.split(" - ")[0].toString()
              )?.projectID,
              amount: response.data.result.totalAmount,
            },
          ]);
          // [
          //   {
          //     jobNumber: allProjects.find(
          //       (project) =>
          //         project.projectKey ===
          //         response.data.result.jobNumber.split(" - ")[0]
          //     )?.projectKey,
          //     amount: "",
          //   },
          // ]
        }
        setFormValues({
          selectedSupplier: selectedSupplierArray,
          invoiceDate: response.data.result.invoiceGeneratedDate,
          billNo: response.data.result.billNo,
          selectedCurrency: selectedCurrencyToShow,
          totalAmount: response.data.result.totalAmount,
          jobNoMapping: response.data.result.jobNoMapping,
          jobNumber: response.data.result.jobNumber,
          selectedManager: selectedManagerArray,
          selectedSeniorManager: selectedSeniorManagerArray,
          selectedDirector: selectedDirectorArray,
          poNumber: response.data.result.poNumber,
          selectedCompany: response.data.result.companyID,
          commentBySuperAdmin: response.data.result.commentBySuperAdmin,
          commentByManager: response.data.result.commentByManager,
          commentBySeniorManager: response.data.result.commentBySeniorManager,
          commentByDirector: response.data.result.commentByDirector,
          createdByID: response.data.result.createdByID,
          finalApproval: response.data.result.finalApproval,
          firstTimeChange: true,
        });
      }
      setViewFile(response.data.result.fileNameS3);
    } catch (error) {
      console.error("Error fetching invoice details:", error);
    } finally {
      setInvoiceDetailsLoading(false);
    }
  };

  // const fetchAllProjects = async () => {
  //   try {
  //     const response = await axios.get("tl-admin/project/all?page=-1");
  //     // const projectsWithTBC = [
  //     //   { projectKey: "TBC", name: "To Be Confirmed", projectID: 0 },
  //     //   ...response.data.result,
  //     // ];
  //     const projectsWithTBC = response.data.result.sort((a: any, b: any) => {
  //       if (a.projectKey === "TBC") return -1;
  //       if (b.projectKey === "TBC") return 1;
  //       return 0;
  //     });
  //     setAllProjects(projectsWithTBC);
  //     setAllProjectsOptions(projectsWithTBC);
  //   } catch (error) {
  //     const errorMessage = getErrorMessage(error);
  //     showError(errorMessage, toast);
  //   }
  // };

  const fetchAllProjects = async () => {
    try {
      const response = await axios.get("tl-admin/project/all?page=-1");
      setNewAllProjects(response.data.result);
      const projectsWithTBC = response.data.result
        .filter((project: any) => project.isActive === true)
        .sort((a: any, b: any) => {
          // Always put TBC first
          if (a.projectKey === "TBC") return -1;
          if (b.projectKey === "TBC") return 1;

          // Extract last 6 characters and convert to numbers
          const aKey = parseInt(a.projectKey.slice(-6), 10) || 0;
          const bKey = parseInt(b.projectKey.slice(-6), 10) || 0;

          // Compare numerically in DESCENDING order (bKey - aKey)
          return bKey - aKey;
        });
      setAllProjects(projectsWithTBC);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      showError(errorMessage, toast);
    }
  };

  const fetchSuppliers = async () => {
    try {
      setSuppliersListLoading(true);
      const response = await axios.get("invoice/supplier/all?page=-1");
      setSuppliersListLoading(false);
      if (Array.isArray(response.data.result)) {
        setSuppliers(response.data.result);
      } else {
        setSuppliersListLoading(false);
        console.error("API response is not an array");
      }
    } catch (error) {
      console.error("Error fetching suppliers:", error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const response = await axios.get("user/currency");
      if (Array.isArray(response.data.result)) {
        setCurrency(response.data.result);
        const defaultCurrency = response.data.result.find(
          (currency: { currencySymbol: string }) =>
            currency.currencySymbol === "£"
        );
        if (defaultCurrency && !invoiceParam) {
          handleInputChange("selectedCurrency", defaultCurrency); // Set Pound as default
        }
      } else {
        console.error("API response is not an array");
      }
    } catch (error) {
      console.error("Error fetching currency:", error);
    }
  };

  useEffect(() => {
    fetchAllProjects();
  }, [isEdit]);

  const fetchManagers = async () => {
    try {
      setInvoiceDetailsLoading(true); // Set loading to true when fetching data
      const response = await axios.get(
        `user/list?roleID=2&page=-1&addInvoice=true`
      ); // API endpoint for managers (roleID 2)
      setInvoiceDetailsLoading(false); // Set loading to true when fetching data
      setManagers((prevManagers) => {
        const newManagers = response.data.result;

        // Find and separate the "Not Required" user
        const notRequiredUser = newManagers.find(
          (manager: User) =>
            manager.firstName === "Not" && manager.lastName === "Required"
        );

        // Filter out the "Not Required" manager from the rest of the array
        const remainingManagers = newManagers.filter(
          (manager: User) =>
            !(manager.firstName === "Not" && manager.lastName === "Required")
        );

        // Rebuild the array: place "Not Required" at the front, followed by previous managers and new remaining managers
        return notRequiredUser
          ? [notRequiredUser, ...prevManagers, ...remainingManagers]
          : [...prevManagers, ...newManagers];
      });
    } catch (error) {
      console.error("Error fetching managers:", error);
    } finally {
      setInvoiceDetailsLoading(false);
    }
  };

  const fetchSeniorManagers = async () => {
    try {
      setInvoiceDetailsLoading(true);
      const response = await axios.get(
        `user/list?roleID=15&page=-1&addInvoice=true`
      ); // API endpoint for senior managers (roleID 7)
      setInvoiceDetailsLoading(false);
      setSeniorManagers((prevSeniorManagers) => {
        const newSeniorManagers = response.data.result;

        // Find and separate the "Not Required" user
        const notRequiredUser = newSeniorManagers.find(
          (seniorManager: User) =>
            seniorManager.firstName === "Not" &&
            seniorManager.lastName === "Required"
        );

        // Filter out the "Not Required" senior manager from the rest of the array
        const remainingSeniorManagers = newSeniorManagers.filter(
          (seniorManager: User) =>
            !(
              seniorManager.firstName === "Not" &&
              seniorManager.lastName === "Required"
            )
        );

        // Rebuild the array: place "Not Required" at the front, followed by previous senior managers and new remaining senior managers
        return notRequiredUser
          ? [notRequiredUser, ...prevSeniorManagers, ...remainingSeniorManagers]
          : [...prevSeniorManagers, ...newSeniorManagers];
      });
    } catch (error) {
      console.error("Error fetching senior managers:", error);
    } finally {
      setInvoiceDetailsLoading(false);
    }
  };

  const fetchDirectors = async () => {
    try {
      setInvoiceDetailsLoading(true);
      const response = await axios.get(
        "user/list?roleID=3&page=-1&addInvoice=true"
      ); // API endpoint for directors
      setInvoiceDetailsLoading(false);

      if (Array.isArray(response.data.result)) {
        setDirectors((prevDirectors) => {
          const newDirectors = response.data.result;

          // Find and separate the "Not Required" user
          const notRequiredUser = newDirectors.find(
            (director: User) =>
              director.firstName === "Not" && director.lastName === "Required"
          );

          // Filter out the "Not Required" senior manager from the rest of the array
          const remainingDirectors = newDirectors.filter(
            (director: User) =>
              !(
                director.firstName === "Not" && director.lastName === "Required"
              )
          );

          // Rebuild the array: place "Not Required" at the front, followed by previous senior managers and new remaining senior managers
          return notRequiredUser
            ? [notRequiredUser, ...prevDirectors, ...remainingDirectors]
            : [...prevDirectors, ...newDirectors];
        });
        // setDirectors(response.data.result); // Set director data
      }
      setSelectedDirectorEmail(
        response.data.result.find(
          (director: any) =>
            director.userID === formValues?.selectedDirector?.userID
        )
      );
    } catch (error) {
      console.error("Error fetching directors:", error);
    } finally {
      setInvoiceDetailsLoading(false);
    }
  };

  const fetchCompanies = async () => {
    try {
      setInvoiceDetailsLoading(true);
      const response = await axios.get("user/companies"); // API endpoint for companies
      setInvoiceDetailsLoading(false);

      if (Array.isArray(response.data.result)) {
        setCompanies(response.data.result); // Set company data
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
      setInvoiceDetailsLoading(false);
    } finally {
      setInvoiceDetailsLoading(false);
    }
  };

  const fetchStatuses = async () => {
    try {
      const response = await axios.get("/user/status");
      if (response.data.StatusCode === 200) {
        setStatuses(response.data.result);
      } else {
        console.error(response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching statuses:", error);
    }
  };

  useEffect(() => {
    if (invoiceParam) {
      setInvoiceID(invoiceParam);
      setIsInvoicePresent(true);
      setIsEdit(false);
      setInvoiceDetailsLoading(true);

      fetchSuppliers();
      fetchAllProjects();
      fetchCurrencies();
      fetchManagers();
      fetchSeniorManagers();
      fetchDirectors();
      fetchCompanies();
      fetchStatuses();

      fetchInvoice(); // Call the fetchInvoice function here
    } else if (isNaN(invoiceParam)) {
      navigate("/layout/invoice-management");
    } else {
      fetchSuppliers();
      fetchAllProjects();
      fetchCurrencies();
      fetchManagers();
      fetchSeniorManagers();
      fetchDirectors();
      fetchCompanies();
      fetchStatuses();
      setFormValues((prevValues: any) => ({
        ...prevValues,
        selectedSupplier: null,
        invoiceDate: null,
        billNo: null,
        selectedCurrency: null,
        totalAmount: null,
        jobNoMapping: [],
        jobNumber: null,
        selectedManager: null,
        selectedSeniorManager: null,
        selectedDirector: null,
        poNumber: null,
        selectedCompany: null,
        commentBySuperAdmin: null,
        commentByManager: null,
        commentBySeniorManager: null,
        commentByDirector: null,
        firstTimeChange: false,
      }));
    }
  }, []);

  useEffect(() => {
    if (selectedDirectorEmail === CATHERINE_O_NEILL.userEmail) {
      setIsFinalApproval(false);
    }
  }, [formValues?.selectedDirector]);

  useEffect(() => {
    const fetchInvoiceActivity = async () => {
      if (invoiceID === null) return;
      try {
        const response = await axios.get(
          `invoice/get-invoice-history?invoiceID=${invoiceID}`
        );

        setInvoiceActivity(response.data.result);
      } catch (error) {
        console.error("Error fetching invoice details:", error);
      }
    };
    fetchInvoiceActivity();
  }, [invoiceID]);

  // On form load, set original values only once
  useEffect(() => {
    setOriginalValues({ ...formValues });
  }, [formValues?.firstTimeChange]);
  // Detect changes in form values
  useEffect(() => {
    if (originalValues?.firstTimeChange) {
      // Use deep comparison for detecting changes
      const hasChanges =
        formValues &&
        Object.keys(formValues).some((key) => {
          if (key === "selectedCurrency") {
            // Compare only the currencySymbol for selectedCurrency
            return (
              formValues?.selectedCurrency?.currencySymbol !==
              originalValues.selectedCurrency?.currencySymbol
            );
          } else if (key === "selectedSupplier") {
            return (
              formValues?.selectedSupplier?.displayName.split(" -")[0] !==
              originalValues.selectedSupplier?.displayName
            );
          } else if (key === "selectedManager") {
            return (
              formValues?.selectedManager?.displayName !==
              originalValues.selectedManager?.displayName
            );
          } else if (key === "selectedSeniorManager") {
            return (
              formValues?.selectedSeniorManager?.displayName !==
              originalValues.selectedSeniorManager?.displayName
            );
          } else if (key === "selectedDirector") {
            return (
              formValues?.selectedDirector?.displayName !==
              originalValues.selectedDirector?.displayName
            );
          }
          // Compare other keys normally
          if (key === "finalApproval") {
            return formValues.finalApproval !== originalValues.finalApproval;
          }
          return formValues[key] !== originalValues[key];
        });
      setIsFormModified(hasChanges);
    }
  }, [formValues, isFinalApproval]);

  // Handle input changes
  const handleInputChange = (key: any, value: any) => {
    if (key === "totalAmount") {
      setFormValues((prevValues: any) => ({
        ...prevValues,
        totalAmount: value,
        jobNoMapping: [
          {
            ...prevValues.jobNoMapping[0],
            amount: value,
          },
        ],
      }));
    }
    setFormValues((prevValues: any) => ({ ...prevValues, [key]: value }));
  };

  const events: TimelineEvent[] = invoiceActivity.map((activity: any) => {
    return {
      poNo: activity.poNumber,
      date: activity.invoiceCreatedDate,
      activity: activity.comment,
      statusID: activity.statusID,
      status: activity.status,
      displayName: activity.displayName,
      comment: activity.comment,
      action: activity.action,
      userEmail: activity.userEmail,
      finalApproval: activity.finalApproval,
    };
  });

  const customizedMarker = () => {
    return (
      <>
        <div className="tw-flex tw-justify-center tw-items-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-[#E2E8F0]">
          <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-[#00AFEE]"></div>
        </div>
      </>
    );
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);

    const day = date.getUTCDate().toString().padStart(2, "0"); // 25
    const month = date.toLocaleString("en-US", { month: "short" }); // Sep
    const year = date.getUTCFullYear(); // 2024

    const time = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${day} ${month} ${year} ${time}`;
  };

  const customizedContent = (item: TimelineEvent) => {
    const renderComment = (comment: string | undefined, userEmail?: string) => {
      if (!comment) return ""; // If comment is an empty string or null, return an empty string

      try {
        const parsedComment = JSON.parse(comment);

        // Check if the parsed comment is an object with expected fields
        if (
          typeof parsedComment === "object" &&
          (parsedComment.confirmJobNumber ||
            parsedComment.confirmSiteName ||
            parsedComment.comment)
        ) {
          // Determine if it's a manager or senior manager based on userEmail or other criteria
          const isManager = userEmail && managers.some(m => m.userEmail === userEmail);
          const isSeniorManager = userEmail && seniorManagers.some(sm => sm.userEmail === userEmail);
          
          const tooltipClass = isManager 
            ? "job-number-tooltip" 
            : isSeniorManager 
            ? "senior-manager-job-number-tooltip" 
            : "job-number-tooltip";

          return (
            <div className="managernotes tw-mr-[155px]">
              <div className="tw-flex tw-ml-0 tw-flex-col tw-gap-2 tw-mt-2 tw-pt-2 tw-pr-3 tw-pb-2">
                <div className={`tw-text-[#6611119c] tw-ml-0`}>
                  <div>
                    <strong>Job Number:</strong>{" "}
                    {parsedComment.confirmJobNumber?.length > 200 ? (
                      <>
                        <Tooltip
                          target={`.${tooltipClass}`}
                          mouseTrack
                          mouseTrackLeft={10}
                        />
                        <span
                          className={tooltipClass}
                          data-pr-tooltip={parsedComment.confirmJobNumber}
                        >
                          {parsedComment.confirmJobNumber.substring(0, 200)}...
                        </span>
                      </>
                    ) : (
                      parsedComment.confirmJobNumber
                    )}
                  </div>
                  <div>
                    <strong>Site Name:</strong>{" "}
                    {parsedComment.confirmSiteName ?? ""}
                  </div>
                  <div>
                    <strong>Comment:</strong> {parsedComment.comment ?? ""}
                  </div>
                </div>
              </div>
            </div>
          );
        }
      } catch (error) {
        // If parsing fails, return the comment as a plain string
        return <span>{comment}</span>;
      }

      // If parsing was successful but no expected fields were found, return the comment directly
      return <span>{comment}</span>;
    };

    return (
      <Card className="activity-card">
        <div className="activity-container tw-flex tw-justify-between tw-items-center tw-mb-4">
          <span className="po-number tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
            {item.poNo}
          </span>
          <span className="activity-date tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
            {formatDate(item.date)}
          </span>
        </div>
        <span className="activity-content tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
          {item.action != null
            ? `${item.action} ${item.displayName} ${
                item.statusID === 8 && item.finalApproval
                  ? "(Final Approval Pending)"
                  : ""
              } ${item.comment != null && item.comment !== "" ? ":" : ""}`
            : `${item.status} ${item.statusID === 6 ? "By" : ""} ${
                item.displayName
              }  ${
                item.statusID === 5 &&
                item.finalApproval &&
                item.userEmail === CATHERINE_O_NEILL.userEmail
                  ? "(Final Approval)"
                  : ""
              }  ${item.comment != null && item.comment !== "" ? ":" : ""}`}
        </span>
        <div className="tw-flex tw-justify-between tw-items-center tw-mt-1 tw-font-medium tw-text-[#6611119c]">
          <span className="tw-ml-auto">{renderComment(item.comment)}</span>
        </div>
      </Card>
    );
  };

  useEffect(() => {
    if (error) {
      showError(error, toast);
      setError(null); // Clear the error state after showing the message
    }
  }, [error]);

  const validateForm = (type?: string) => {
    const errors: Record<string, string> = {};
    if (
      !formValues?.selectedSupplier &&
      !formValues?.selectedSupplier?.supplierID
    )
      errors.supplierID = "Supplier is required.";
    if (!formValues?.invoiceDate)
      errors.invoiceDate = "Invoice Date is Required";
    if (!formValues?.billNo || formValues?.billNo?.trim().length === 0)
      errors.billNo = "Bill number is required.";
    if (!formValues?.jobNoMapping || formValues?.jobNoMapping.length === 0)
      errors.jobNoMapping = "Job number is required.";
    if (!formValues?.poNumber || formValues?.poNumber?.trim().length === 0)
      errors.poNumber = "PO number is required.";
    if (!formValues?.totalAmount || formValues?.totalAmount === 0)
      errors.totalAmount = "Total amount is required.";
    if (!formValues?.selectedManager?.userID)
      errors.managerID = "Manager is required.";
    if (!formValues?.selectedSeniorManager?.userID)
      errors.seniorManagerID = "Senior Manager is required.";
    if (!formValues?.selectedDirector?.userID)
      errors.directorID = "Director is required.";
    if (!formValues?.selectedCompany) errors.companyID = "Company is required.";
    if (type === "add") {
      if (!uploadedFile) errors.files = "file must be uploaded.";
      setFileUpLoading(false);
    } else if (type === "update") {
      if (!uploadedFile && !isInvoicePresent)
        errors.files = "file must be uploaded.";
    }
    setFormErrors(errors);
    if (errors.files) {
      setError(errors.files);
    }
    if (Object.keys(errors).length > 0) {
      return false;
    }
    return true;
  };

  const handleRemoveFunction = () => {
    if (!isAddInvoice) {
      setIsInvoicePresent(false);
      setCancelFileOnEdit(true);
      setIsEdit(true);
    }
    setIsAddInvoice(false);
    setUploadedFile(null);
  };

  const handleSubmit = async () => {
    validateForm("add");
    if (!formValues?.selectedSupplier) {
      console.error("No supplier selected");
      return;
    }

    if (!validateForm("add")) {
      return;
    }
    const formData = new FormData();
    const checkInvoiceDuplicateStatus = await checkInvoiceDuplicacy(
      formValues?.selectedSupplier.supplierID,
      formValues?.billNo
    );

    if (checkInvoiceDuplicateStatus === 409) {
      confirmToProceed(async () => {
        await addInvoice(formData);
      });
      return;
    }
    await addInvoice(formData);
  };

  const addInvoice = async (formData: FormData) => {
    formData.append(
      "supplierID",
      String(formValues?.selectedSupplier.supplierID)
    );
    formData.append("billNo", formValues?.billNo?.trim());
    formData.append("jobNoMapping", JSON.stringify(formValues?.jobNoMapping));
    formData.append("poNumber", formValues?.poNumber?.trim());
    if (formValues?.invoiceDate) {
      formData.append(
        "invoiceGeneratedDate",
        formValues?.invoiceDate ? formValues?.invoiceDate : ""
      );
    }
    formData.append(
      "totalAmount",
      formValues?.totalAmount ? formValues?.totalAmount : ""
    ); // Convert number to string
    formData.append(
      "managerID",
      formValues?.selectedManager?.userID
        ? String(formValues?.selectedManager.userID)
        : ""
    );
    formData.append(
      "seniorManagerID",
      formValues?.selectedSeniorManager?.userID
        ? String(formValues?.selectedSeniorManager.userID)
        : ""
    );
    formData.append(
      "directorID",
      formValues?.selectedDirector?.userID
        ? String(formValues?.selectedDirector.userID)
        : ""
    );
    if (formValues.commentBySuperAdmin) {
      formData.append(
        "commentBySuperAdmin",
        formValues?.commentBySuperAdmin?.trim()
      );
    }
    formData.append(
      "currencyID",
      formValues?.selectedCurrency?.currencyID
        ? String(formValues?.selectedCurrency.currencyID)
        : ""
    );
    formData.append(
      "companyID",
      formValues?.selectedCompany ? String(formValues?.selectedCompany) : ""
    );
    // Append the files
    if (files && files.length > 0) {
      files.forEach((file: File) => {
        const modifiedName = file.name.replace(/[^a-zA-Z0-9. ]/g, "");
        const modifiedFile = new File([file], modifiedName, {
          type: file.type,
        });
        formData.append("invoice", modifiedFile);
        // formData.append("invoice", file); // Use a single key for the file uploads
      });
    }
    formData.append("finalApproval", formValues?.finalApproval);

    try {
      setFileUpLoading(true);
      await axios.post("invoice/add-invoice", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Ensure that multipart form data is used
        },
      });
      setFileUpLoading(false);
      showSuccess("Invoice added successfully.", toast);
      navigate("/layout/invoice-management");
    } catch (error: any) {
      // const errorMessage = error.response.data.Message;
      const errorMessage = getErrorMessage(error);

      const errorStatus = error.response.data.StatusCode;
      setError(errorMessage);
      showError(errorMessage, toast);
      if (errorStatus === 409) {
        showError(errorMessage, toast, "Duplicate Invoice");
        setError(null); // Clear the error state after showing the message
      } else {
        setError(errorMessage);
      }
      setInvoiceDetailsLoading(false);
      setFileUpLoading(false);
    }
  };

  const confirmToProceed = (onAccept: () => void) => {
    const currentSupplier = suppliers.filter(
      (supplier) =>
        supplier.supplierID === formValues?.selectedSupplier.supplierID
    );

    confirmDialog({
      message: "Are you sure you want to continue?",
      header: `Invoice with Invoice Number ${formValues?.billNo} and Supplier '${currentSupplier[0].displayName}' already exists.`,
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      draggable: false,
      accept: onAccept, // Call the provided callback on "Yes"
      reject: () => {},
      acceptClassName:
        "tw-bg-primary tw-text-white focus:tw-shadow-none tw-rounded-lg tw-px-4 tw-py-2 tw-font-medium tw-transition-all tw-duration-200", // Tailwind for "Yes"
      rejectClassName:
        "tw-rounded-lg tw-px-4 focus:tw-shadow-none tw-py-2 tw-font-medium tw-transition-all tw-duration-200 ", // Tailwind for "No"
    });
  };

  const checkInvoiceDuplicacy = async (
    supplierID: string,
    billNo: string,
    invoiceID?: string
  ) => {
    try {
      setFileUpLoading(true);
      const response = await axios.get(
        `invoice/check-invoice-exist?supplierID=${supplierID}&billNo=${billNo}${
          invoiceID ? `&invoiceID=${invoiceID}` : ""
        }`
      );
      setFileUpLoading(false);
      return response.data.StatusCode;
    } catch (error: any) {
      setFileUpLoading(false);
      return error.status;
    }
  };

  const handleUpdate = async () => {
    validateForm("update");
    if (!validateForm("update")) {
      return;
    }
    const formData = new FormData();
    const checkInvoiceDuplicateStatus = await checkInvoiceDuplicacy(
      formValues?.selectedSupplier.supplierID,
      formValues?.billNo,
      selectedInvoice.invoiceID
    );

    if (checkInvoiceDuplicateStatus === 409) {
      confirmToProceed(async () => {
        await updateInvoice(formData);
      });
      return;
    }
    await updateInvoice(formData);
  };

  const updateInvoice = async (formData: FormData) => {
    const jobNo = formValues?.jobNoMapping?.projectKey
      ? formValues?.jobNoMapping?.projectKey
      : formValues?.jobNoMapping;

    // Check if only job numbers/amounts changed (order or amounts swapped but total remains same)
    const isJobNoChanged =
      !originalValues.jobNoMapping ||
      formValues.jobNoMapping.length !== originalValues.jobNoMapping.length ||
      !originalValues.jobNoMapping.every((originalJob: any) => {
        const updatedJob = formValues.jobNoMapping.find(
          (job: any) => job.jobNumber === originalJob.jobNumber
        );
        return updatedJob && updatedJob.amount === originalJob.amount;
      });

    // Calculate original and new total amounts
    const originalTotal = originalValues.jobNoMapping?.reduce(
      (sum: number, job: any) => sum + parseFloat(job.amount || 0),
      0
    );
    const newTotal = formValues.jobNoMapping.reduce(
      (sum: number, job: any) => sum + parseFloat(job.amount || 0),
      0
    );

    // Check if total amount is the same (allowing for job number/amount reordering)
    const isTotalAmountSame = originalTotal === newTotal;

    // Check if other fields changed (comparing IDs where applicable)
    const isOtherFieldsChanged =
      originalValues.selectedSupplier?.supplierID !==
        formValues.selectedSupplier?.supplierID ||
      originalValues.invoiceDate !== formValues.invoiceDate ||
      originalValues.billNo !== formValues.billNo ||
      originalValues.selectedCurrency?.currencyID !==
        formValues.selectedCurrency?.currencyID ||
      // originalValues.totalAmount.toString() !==
      //   formValues.totalAmount.toString() ||
      Number(Number(originalValues.totalAmount).toFixed(2)) !==
        Number(Number(formValues.totalAmount).toFixed(2)) ||
      originalValues.selectedManager?.userID !==
        formValues.selectedManager?.userID ||
      originalValues.selectedSeniorManager?.userID !==
        formValues.selectedSeniorManager?.userID ||
      originalValues.selectedDirector?.userID !==
        formValues.selectedDirector?.userID ||
      originalValues.poNumber !== formValues.poNumber ||
      originalValues.selectedCompany !== formValues.selectedCompany ||
      originalValues.commentBySuperAdmin !== formValues.commentBySuperAdmin;
    //  || originalValues.finalApproval !== formValues.finalApproval;

    // Determine if this is only a job number change (order or amounts swapped but total same)
    // and no other fields changed
    const isOnlyJobNo = !isOtherFieldsChanged;

    if (!isEdit) {
      formData.append("invoiceID", selectedInvoice.invoiceID);
      formData.append("billNo", formValues?.billNo?.trim());
      formData.append("jobNoMapping", JSON.stringify(formValues?.jobNoMapping));
      formData.append("poNumber", formValues?.poNumber?.trim());
      formData.append(
        "companyID",
        formValues?.selectedCompany ? String(formValues?.selectedCompany) : ""
      );
    } else {
      formData.append("invoiceID", selectedInvoice.invoiceID);
      formData.append("billNo", formValues?.billNo?.trim());
      formData.append("jobNoMapping", JSON.stringify(formValues?.jobNoMapping));
      formData.append("poNumber", formValues?.poNumber?.trim());
      if (formValues?.invoiceDate) {
        formData.append("invoiceGeneratedDate", formValues?.invoiceDate);
      }
      formData.append(
        "companyID",
        formValues?.selectedCompany ? String(formValues?.selectedCompany) : ""
      );
      formData.append(
        "supplierID",
        String(formValues?.selectedSupplier.supplierID)
      );
      formData.append(
        "managerID",
        formValues?.selectedManager?.userID
          ? String(formValues?.selectedManager.userID)
          : ""
      );
      formData.append(
        "seniorManagerID",
        formValues?.selectedSeniorManager?.userID
          ? String(formValues?.selectedSeniorManager.userID)
          : ""
      );
      formData.append(
        "directorID",
        formValues?.selectedDirector?.userID
          ? String(formValues?.selectedDirector.userID)
          : ""
      );
      formData.append(
        "commentBySuperAdmin",
        formValues?.commentBySuperAdmin?.trim() || ""
      );
      formData.append(
        "currencyID",
        formValues?.selectedCurrency?.currencyID
          ? String(formValues?.selectedCurrency.currencyID)
          : ""
      );
      formData.append(
        "totalAmount",
        formValues?.totalAmount ? String(formValues?.totalAmount) : ""
      );
      if (isOnlyJobNo === true) {
        formData.append("isOnlyJobNo", "1");
      } else {
        formData.append("isOnlyJobNo", "0");
      }
    }

    if (files && files.length > 0) {
      files.forEach((file: File) => {
        const modifiedName = file.name.replace(/[^a-zA-Z0-9. ]/g, "");
        const modifiedFile = new File([file], modifiedName, {
          type: file.type,
        });
        formData.append("invoice", modifiedFile);
      });
    }
    formData.append("finalApproval", formValues?.finalApproval);

    try {
      setFileUpLoading(true);
      await axios.post("invoice/update-invoice", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      showSuccess("Invoice Updated successfully.", toast);
      navigate("/layout/invoice-management");
      setFileUpLoading(false);
    } catch (error: any) {
      console.error("Error adding invoice:", error);
      const errorMessage = error.response?.data?.Message;
      setError(errorMessage || "An error occurred while updating the invoice.");
      setFileUpLoading(false);
    }
  };

  const resetForm = (type?: string) => {
    setFormErrors({});
    if (type === "resetButtonClick") {
      setIsResetForm(true);
    }
    setTempJobEntries([
      {
        jobNumber: "",
        amount: "",
      },
    ]);

    setFormValues({
      selectedSupplier: null,
      invoiceDate: null,
      billNo: null,
      selectedCurrency: {
        currencyID: 2,
        currencyName: "Pound sterling",
        currencySymbol: "£",
        createdDate: "2024-09-23T11:00:26.000Z",
        isActive: true,
      },
      totalAmount: null,
      jobNoMapping: [],
      jobNumber: null,
      selectedManager: null,
      selectedSeniorManager: null,
      selectedDirector: null,
      poNumber: null,
      selectedCompany: null,
      commentBySuperAdmin: null,
      commentByManager: null,
      commentBySeniorManager: null,
      commentByDirector: null,
      firstTimeChange: false,
    });
    if (!isAddInvoice) {
      setIsInvoicePresent(false);
      setCancelFileOnEdit(true);
      setIsEdit(true);
    }
    setIsFinalApproval(false);
    setIsAddInvoice(false);
    setUploadedFile(null);
  };

  const editButtonCall = () => {
    setIsEdit(true);
    // const isJobNoInProjectExists =
    //   selectedInvoice &&
    //   allProjects.find(
    //     (project) =>
    //       project.projectKey === selectedInvoice.jobNoMapping.split(" -")[0]
    //   );
    // // alert(isJobNoInProjectExists)
    // if (!isJobNoInProjectExists) {
    //   setFormValues((prevValues: any) => ({
    //     ...prevValues,
    //     jobNoMapping: null,
    //   }));
    //   setOriginalValues((prevValues: any) => ({
    //     ...prevValues,
    //     jobNoMapping: null,
    //   }));
    // }
  };
  const cancelFileOnEditBtn = () => {
    // checking if there is status is 1 or 3 or 5 then set file edit also true
    if (
      selectedInvoice.statusID === 1 ||
      selectedInvoice.statusID === 3 ||
      selectedInvoice.statusID === 5
    ) {
      setCancelFileOnEdit(true);
    }
  };

  const InvoiceDateConst = (date: string | null): void => {
    // Use the date directly from the Calendar component without converting to UTC
    const formattedDate = date
      ? new Date(new Date(date).toLocaleDateString("en-CA"))
          .toISOString()
          .split("T")[0] // Format as 'YYYY-MM-DD'
      : null;
    handleInputChange("invoiceDate", formattedDate);
  };
  const getOriginalDate = (formattedDate: string | null): Date | null => {
    if (!formattedDate) return null;

    const dateObject = new Date(formattedDate + "T00:00:00");

    return dateObject;
  };
  const addInvoiceSetAll = () => {
    setFormValues({
      selectedSupplier: null,
      invoiceDate: null,
      billNo: null,
      selectedCurrency: null,
      totalAmount: null,
      jobNoMapping: [],
      jobNumber: null,
      selectedManager: null,
      selectedSeniorManager: null,
      selectedDirector: null,
      poNumber: null,
      selectedCompany: null,
      commentBySuperAdmin: null,
      commentByManager: null,
      commentBySeniorManager: null,
      commentByDirector: null,
      firstTimeChange: false,
    });
    setIsInvoicePresent(false);
    setIsEdit(false);
    setInvoiceDetailsLoading(false);
    setViewFile("");
    resetForm();
    navigate("/layout/add-invoice");
  };
  const supplierValueTemplate = (option: any) => {
    if (!option) {
      return (
        <span>
          {formValues?.selectedSupplier?.displayName || "Select Supplier"}
        </span>
      );
    }

    return <span>{option.displayName}</span>;
  };

  const managerValueTemplate = (option: any) => {
    if (!option) {
      return (
        <span>
          {formValues?.selectedManager?.displayName || "Select Manager"}
        </span>
      );
    }

    return <span>{option.displayName}</span>;
  };

  const seniorManagerValueTemplate = (option: any) => {
    if (!option) {
      return (
        <span>
          {formValues?.selectedSeniorManager?.displayName ||
            "Select Senior Manager"}
        </span>
      );
    }

    return <span>{option.displayName}</span>;
  };

  const directorValueTemplate = (option: any) => {
    if (!option) {
      return (
        <span>
          {formValues?.selectedDirector?.displayName || "Select Director"}
        </span>
      );
    }

    return <span>{option.displayName}</span>;
  };

  const handleApprove = () => {
    setCommentType("Approved");
    if (confirmJobNo.length === 0) {
      setConfirmJobNo(
        formValues?.jobNoMapping?.map((job: any) =>
          allProjects.find(
            (project: any) => project.projectID === job.jobNumber
          )
        ) ?? []
      );
    }
    setApproveRejectDialog(true);
  };
  const handleReject = () => {
    setCommentType("Rejected");
    setApproveRejectDialog(true);
  };

  const handleApproveReject = async () => {
    if (
      localStorage.roleName.includes(ROLES.MANAGER) ||
      localStorage.roleName.includes(ROLES.SENIOR_MANAGER)
    ) {
      if (commentType === "Approved" && confirmJobNo?.length === 0) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          confirmJobNo: "Please Confirm the Job No.",
        }));
        return;
      } else if (
        commentType === "Approved" &&
        confirmSiteName?.trim().length === 0
      ) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          confirmSiteName: "Please Confirm the Site Name",
        }));
        return;
      }
    }

    if (
      commentType === "Rejected" &&
      approveRejectComment?.trim().length === 0
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        comment: "Comments are required!",
      }));
      return;
    }
    // const status = statuses.find(
    //   (status) =>
    //     status.displayName === commentType + " By " + localStorage.roleName
    // );
    // const status = statuses.find(
    //   (status) =>
    //     status.displayName === commentType + " By " + localStorage.roleName.includes(ROLES.MANAGER) ? ROLES.MANAGER : ROLES.DIRECTOR
    // );
    // Determine the role based on localStorage.roleName
    const role = localStorage.roleName.includes(ROLES.SENIOR_MANAGER)
      ? ROLES.SENIOR_MANAGER
      : localStorage.roleName.includes(ROLES.MANAGER)
      ? ROLES.MANAGER
      : ROLES.DIRECTOR;

    // Construct the displayName to search for
    const displayNameToFind = `${commentType} By ${role}`;
    // Find the status with the matching displayName
    const status = statuses.find(
      (status) => status.displayName === displayNameToFind
    );

    const approvedData =
      (localStorage.roleName.includes(ROLES.MANAGER) ||
        localStorage.roleName.includes(ROLES.SENIOR_MANAGER)) &&
      commentType === "Approved"
        ? JSON.stringify({
            confirmJobNumber: confirmJobNo
              .map((job: any) => job.projectKey)
              .join(" || "),
            confirmSiteName: confirmSiteName?.trim(),
            comment: approveRejectComment?.trim(),
          })
        : approveRejectComment?.trim();

    const data = {
      invoiceID: selectedInvoice.invoiceID,
      comment: approvedData,
      status:
        localStorage.userEmail !== CATHERINE_O_NEILL.userEmail &&
        formValues?.finalApproval &&
        commentType === "Approved" &&
        localStorage.roleName.includes(ROLES.DIRECTOR)
          ? 8
          : status?.statusID,
    };
    setIsApproveRejectButtonDisabled(true);
    const response = await axios.post("/invoice/updateStatus", data);
    setIsApproveRejectButtonDisabled(false);

    if (response.data.StatusCode === 200) {
      showSuccess("Invoice " + commentType + " successfully.", toast);
      navigate("/layout/invoice-management");
    } else {
      showError("Error " + commentType + " invoice.", toast);
      setIsApproveRejectButtonDisabled(false);
    }
  };
  const handleEntry = async () => {
    const data = {
      invoiceID: selectedInvoice.invoiceID,
      status: 6,
    };
    setIsEntryButtonDisabled(true);
    const response = await axios.post("/invoice/updateStatus", data);
    setIsEntryButtonDisabled(false);

    if (response.data.StatusCode === 200) {
      showSuccess("Invoice Entry successful.", toast);
      navigate("/layout/invoice-management");
    } else {
      showError("Error Entering invoice.", toast);
      setIsEntryButtonDisabled(false);
    }
  };

  const reject = () => {
    setIsConfirmEntryDialogOpen(false);
    toast?.current?.show({
      severity: "warn",
      summary: "Rejected",
      detail: "You have rejected",
      life: 3000,
    });
  };

  const parseComment = (commentByManager: any) => {
    if (!commentByManager) {
      return {
        confirmJobNumber: "N/A",
        confirmSiteName: "N/A",
        comment: "N/A",
      };
    }

    try {
      const parsed = JSON.parse(commentByManager);
      return {
        confirmJobNumber: parsed.confirmJobNumber || "N/A",
        confirmSiteName: parsed.confirmSiteName || "N/A",
        comment: parsed.comment || "N/A",
      };
    } catch (error) {
      return {
        confirmJobNumber: "N/A",
        confirmSiteName: "N/A",
        comment: commentByManager,
      };
    }
  };

  const jobNumberOptionsTemplate = (option: any) => {
    return (
      <div
      // className={
      //   invoiceRoleIDs && invoiceRoleIDs.includes(option.roleID)
      //     ? "tw-text-blue-800"
      //     : option.moduleID.toString() !== localStorage.currentModuleID
      //     ? "tw-text-gray-400"
      //     : ""
      // }
      // className="tw-w-[2px]"
      >
        {option.projectKey} - {option.name}
      </div>
    );
  };

  const jobNumberValueTemplate = (option: any) => {
    if (!option) {
      return "Select Job Number";
    }
    return (
      <div>
        {option.projectKey} - {option.name}
      </div>
    );
  };

  const handleJobNumberChange = (index: number, value: any) => {
    if (index < 0 || index >= tempJobEntries.length) {
      console.error("Invalid index for tempJobEntries:", index);
      return;
    }

    setTempJobEntries((prevEntries: any) => {
      const updatedEntries = [...prevEntries];
      updatedEntries[index] = {
        ...updatedEntries[index],
        jobNumber: value.projectID,
      };
      return updatedEntries;
    });

    setValidationErrors((prevErrors) => {
      const updatedErrors = [...prevErrors];
      updatedErrors[index] = {
        ...updatedErrors[index],
        jobNumber: !value.projectID,
      };
      return updatedErrors;
    });
    setFormValues((prevValues: any) => ({
      ...prevValues,
      jobNoMapping: [
        {
          jobNumber: value.projectID,
          amount: tempJobEntries[index].amount,
        },
      ],
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      jobNoMapping: null,
    }));
    setIsResetForm(false);
  };

  const handleAmountChange = (index: number, value: any) => {
    // Validate index
    if (index < 0 || index >= tempJobEntries.length) {
      console.error("Invalid index for tempJobEntries:", index);
      return;
    }

    // Safely update tempJobEntries
    setTempJobEntries((prevEntries: any) => {
      const updatedEntries = [...prevEntries];
      updatedEntries[index] = {
        ...updatedEntries[index],
        amount: value,
      };
      return updatedEntries;
    });

    // Safely update validationErrors
    setValidationErrors((prevErrors: any) => {
      const updatedErrors = [...prevErrors];
      updatedErrors[index] = {
        ...updatedErrors[index],
        amount: !value,
      };
      return updatedErrors;
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        group="declarative"
        visible={isConfirmEntryDialogOpen}
        onHide={() => setIsConfirmEntryDialogOpen(false)}
        message="Are you sure you want to proceed?"
        header="Confirmation"
        icon="pi pi-exclamation-triangle"
        footer={() => (
          <div className="flex gap-2">
            <Button
              onClick={handleEntry}
              className="tw-bg-primary hover:tw-bg-[#152846] tw-text-white focus:tw-shadow-none tw-rounded-lg tw-px-4 tw-py-2 tw-font-medium tw-transition-all tw-duration-200"
              disabled={isEntryButtonDisabled}
            >
              Yes
            </Button>
            <Button
              onClick={reject}
              className="tw-rounded-lg tw-px-4 focus:tw-shadow-none tw-py-2 tw-font-medium tw-transition-all tw-duration-200"
            >
              No
            </Button>
          </div>
        )}
      />
      <div className="add-invoice-container">
        {fileUploading && (
          <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
            <ProgressSpinner />
          </div>
        )}
        <ConfirmDialog />
        <div className="a-card">
          {invoiceParam &&
          (localStorage.roleName.includes(ROLES.SUPER_ADMIN) ||
            localStorage.roleName.includes(ROLES.ACCOUNTANT)) ? (
            <div className="card-header tw-flex tw-justify-end tw-items-center tw-bg-[#F8FAFC]">
              <Button
                className="tw-ml-0 tw-flex tw-flex-1 tw-px-3 tw-py-2 tw-rounded bg-primary border-primary tw-text-white tw-font-medium"
                label="Add Invoice"
                icon="pi pi-plus"
                onClick={addInvoiceSetAll}
                disabled={invoiceDetailsLoading && !formValues.firstTimeChange}
              />
            </div>
          ) : null}
          <div className="invoice-form a-card tw-relative">
            {invoiceParam ? null : (
              <div className="card-header">
                <h2 className="card-title">Add Invoice</h2>
              </div>
            )}
            <TabView
              className={
                invoiceParam ? "tab-container" : "tab-container hide-tabs"
              }
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Details">
                {invoiceParam &&
                (localStorage.roleName.includes(ROLES.SUPER_ADMIN) ||
                  localStorage.roleName.includes(ROLES.ACCOUNTANT)) ? (
                  <>
                    {isEdit ? (
                      <button
                        type="button"
                        className="tw-absolute tw-top-3 tw-right-4 tw-rounded-md tw-bg-sky-500 tw-px-2 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-sky-400 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-sky-500"
                        onClick={() => {
                          setIsEdit(false);
                          setCancelFileOnEdit(false);
                          setIsInvoicePresent(true);
                          setIsFormModified(false);
                        }}
                        disabled={Object.entries(formValues).some(
                          ([key, value]) => {
                            const originalValue = originalValues[key];
                            return value === null && originalValue !== null;
                          }
                        )}
                      >
                        <FeatherIcon icon="x" />
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="tw-absolute tw-top-3 tw-right-4 tw-rounded-md tw-bg-sky-500 tw-px-2 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-sky-400 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-sky-500"
                        onClick={editButtonCall}
                      >
                        <FeatherIcon icon="edit-2" />
                      </button>
                    )}
                  </>
                ) : null}

                <div className="card-body tw-relative tw-flex tw-pt-0 tw-pr-0">
                  {invoiceDetailsLoading ? (
                    <div className="tw-h-full tw-w-full tw-bg-white tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
                      <ProgressSpinner />
                    </div>
                  ) : (
                    <div className="">
                      <div className="suppliername">
                        <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                          <label
                            htmlFor="SupplierName"
                            className="tw-mt-2 tw-font-semibold"
                          >
                            Supplier Name
                          </label>
                          <Dropdown
                            id="SupplierName"
                            value={formValues?.selectedSupplier ?? {}}
                            onChange={(e) => {
                              setFormErrors((prevErrors) => ({
                                ...prevErrors,
                                supplierID: null,
                              }));
                              handleInputChange("selectedSupplier", e.value);
                            }}
                            options={suppliers}
                            optionLabel="displayName"
                            valueTemplate={supplierValueTemplate}
                            filter
                            disabled={isInvoicePresent && !isEdit}
                            placeholder="Select Supplier"
                            className={`tw-h-11 tw-relative tw-border tw-border-solid ${
                              formErrors.supplierID
                                ? "tw-border-red-600"
                                : "tw-border-gray-300"
                            } tw-rounded-md placeholder:tw-font-normal tw-w-full filter-dropdown`}
                            loading={suppliersListLoading}
                            required
                          />
                        </div>
                      </div>
                      <div className="invoiceDate tw-mt-2">
                        <div className="tw-flex tw-grid-cols-2 tw-gap-2">
                          <label
                            htmlFor="UploadedOn"
                            className="tw-mt-3 tw-w-1/2 tw-font-semibold"
                          >
                            Invoice Date
                          </label>
                          <Calendar
                            className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid ${
                              formErrors.invoiceDate
                                ? "tw-border-red-600"
                                : "tw-border-gray-300"
                            } tw-rounded-md tw-h-11 placeholder:tw-font-normal tw-w-1/2 tw-ms-3`}
                            dateFormat="dd-mm-yy"
                            placeholder="Select Invoice Date"
                            maxDate={new Date()}
                            value={
                              getOriginalDate(formValues?.invoiceDate) as any
                            }
                            disabled={isInvoicePresent && !isEdit}
                            onChange={(e) => {
                              setFormErrors((prevErrors) => ({
                                ...prevErrors,
                                invoiceDate: null,
                              }));
                              InvoiceDateConst(e.target.value as any);
                            }}
                            showIcon
                            required
                          />
                        </div>
                      </div>
                      <div className="bill-no tw-mt-2">
                        <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                          <label
                            htmlFor="BillNo"
                            className="tw-mt-3 tw-font-semibold"
                          >
                            Bill No
                          </label>
                          <InputText
                            type="text"
                            className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid ${
                              formErrors.billNo
                                ? "tw-border-red-600"
                                : "tw-border-gray-300"
                            } tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                            placeholder="Enter Bill No"
                            id="PONo"
                            aria-describedby="bill-no-help"
                            value={formValues?.billNo ?? ""}
                            disabled={isInvoicePresent && !isEdit}
                            onChange={(e) => {
                              if (formValues?.billNo?.length === 1) {
                                setFormErrors((prevErrors) => ({
                                  ...prevErrors,
                                  billNo: null,
                                }));
                              }
                              handleInputChange("billNo", e.target.value);
                            }}
                            invalid={!!formErrors.billNo}
                          />
                        </div>
                      </div>
                      {isFirstJobNumber &&
                      (formValues?.jobNoMapping?.length <= 1 ||
                        !invoiceParam) ? (
                        <div className="total tw-mt-2">
                          <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                            <label
                              htmlFor="Total"
                              className="tw-mt-3 tw-font-semibold"
                            >
                              Total
                            </label>
                            <div className="flex-1 p-inputgroup">
                              {isEdit || !invoiceParam ? (
                                <Dropdown
                                  id="Currency"
                                  value={formValues?.selectedCurrency ?? {}}
                                  onChange={(e) => {
                                    setFormValues((prev: any) => ({
                                      ...prev,
                                      selectedCurrency: e.target.value,
                                    }));
                                  }}
                                  options={currency} // Pass currency to Dropdown
                                  optionLabel="currencySymbol" // Display country names
                                  placeholder={`${
                                    isEdit && invoiceParam
                                      ? formValues?.selectedCurrency
                                          ?.currencySymbol
                                      : "Select Currency"
                                  }`}
                                  disabled={isInvoicePresent && !isEdit}
                                  tooltip={`${
                                    invoiceParam
                                      ? ""
                                      : formValues?.selectedCurrency
                                      ? ""
                                      : "Select Currency"
                                  }`}
                                  tooltipOptions={{ position: "bottom" }}
                                  className={`tw-h-11 tw-border tw-border-solid ${
                                    formErrors.totalAmount
                                      ? "tw-border-red-600"
                                      : "tw-border-gray-300"
                                  } placeholder:tw-font-normal tw-rounded-none tw-rounded-l tw-border-r-0 filter-dropdown tw-w-16`}
                                />
                              ) : (
                                <span
                                  className={`tw-px-3 tw-rounded-l tw-text-gray-400 tw-py-2 tw-border-l tw-border-t tw-border-b tw-border-r-0 tw-h-11 tw-flex tw-items-center tw-bg-gray-100`}
                                >
                                  {formValues?.selectedCurrency?.currencySymbol}
                                </span>
                              )}

                              <InputNumber
                                className={`tw-px-[14px] ${
                                  isEdit ? "tw-pl-6" : ""
                                } tw-rounded-r tw-text-sm tw-py-[5px] tw-border tw-border-solid ${
                                  formErrors.totalAmount
                                    ? "tw-border-red-600"
                                    : "tw-border-gray-300"
                                } tw-rounded-none tw-border-l-0 tw-h-11 placeholder:tw-font-normal tw-w-full`}
                                placeholder="Amount"
                                // readOnly
                                id="Amount"
                                aria-describedby="amount-help"
                                disabled={isInvoicePresent && !isEdit}
                                value={formValues?.totalAmount ?? 0} // Ensure value is a number
                                onKeyDown={(evt) => {
                                  if (
                                    evt.key === "e" ||
                                    evt.key === "E" ||
                                    evt.key === "+" ||
                                    evt.key === "-" ||
                                    evt.key === "ArrowUp" ||
                                    evt.key === "ArrowDown"
                                  ) {
                                    evt.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  setFormErrors((prevErrors) => ({
                                    ...prevErrors,
                                    totalAmount: null,
                                  }));
                                  handleAmountChange(0, e.value?.toString());
                                  handleInputChange("totalAmount", e.value);
                                }} // Update state with valid number or null
                                // onKeyDown={(evt) => {
                                //   if (
                                //     evt.key === "e" ||
                                //     evt.key === "E" ||
                                //     evt.key === "+" ||
                                //     evt.key === "-" ||
                                //     evt.key === "ArrowUp" ||
                                //     evt.key === "ArrowDown"
                                //   ) {
                                //     evt.preventDefault();
                                //   }
                                // }}
                                // onChange={(e) => {
                                //   setFormErrors((prevErrors) => ({
                                //     ...prevErrors,
                                //     totalAmount: null,
                                //   }));
                                //   handleAmountChange(0, e.target.value);
                                //   handleInputChange(
                                //     "totalAmount",
                                //     e.target.value
                                //   );
                                // }} // Update state with number or null
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="total tw-mt-2">
                          <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                            <label
                              htmlFor="Total"
                              className="tw-mt-3 tw-font-semibold"
                            >
                              Total
                            </label>
                            <div className="flex-1 p-inputgroup">
                              <InputText
                                type="text"
                                className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid ${
                                  formErrors.totalAmount
                                    ? "tw-border-red-600"
                                    : "tw-border-gray-300"
                                } tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                                placeholder="Amount"
                                id="totalAmount"
                                readOnly
                                aria-describedby="bill-no-help"
                                value={`${
                                  formValues?.selectedCurrency
                                    ?.currencySymbol ?? ""
                                }${"  "}${
                                  formatGBPForAmountEntry(
                                    formValues?.totalAmount
                                  ) ?? 0
                                }`}
                                disabled={isInvoicePresent && !isEdit}
                                invalid={!!formErrors.totalAmount}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {/* <div className="jobno tw-mt-2">
                        <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                          <label htmlFor="JobNo" className="tw-mt-3">
                            Job No
                          </label>
                          <InputText
                            type="text"
                            className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid ${
                              formErrors.jobNoMapping
                                ? "tw-border-red-600"
                                : "tw-border-gray-300"
                            } tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                            placeholder="Enter Job No"
                            id="JobNo"
                            aria-describedby="job-no-help"
                            value={formValues?.jobNoMapping ?? ""}
                            disabled={isInvoicePresent && !isEdit}
                            onChange={(e) => {
                              setFormErrors((prevErrors) => ({
                                ...prevErrors,
                                jobNoMapping: null,
                              }));
                              handleInputChange("jobNoMapping", e.target.value);
                            }}
                          />
                        </div>
                      </div> */}
                      {/* {isEdit || !invoiceParam ? (
                        <div className="jobno tw-mt-2">
                          <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                            <label htmlFor="JobNo" className="tw-mt-3 tw-font-semibold">
                              Job No
                            </label>
                            <Dropdown
                              id=""
                              value={selectedJobNo ?? ""}
                              onChange={(e) => {
                                setFormErrors((prevErrors) => ({
                                  ...prevErrors,
                                  jobNoMapping: null,
                                }));
                                setSelectedJobNo(e.target.value);
                                const jobNo = `${e.target.value.projectKey} - ${e.target.value.name}`;
                                handleInputChange("jobNoMapping", jobNo);
                              }} // Store selected manager
                              loading={projectsLoading}
                              itemTemplate={jobNumberOptionsTemplate}
                              options={allProjects} // Pass managers to Dropdown
                              // Display projectKey and name
                              placeholder="Select Job No"
                              valueTemplate={jobNumberValueTemplate}
                              // filter
                              disabled={isInvoicePresent && !isEdit}
                              className={`tw-h-11 tw-border tw-border-solid ${
                                formErrors.jobNoMapping
                                  ? "tw-border-red-600"
                                  : "tw-border-gray-300"
                              } tw-rounded-md placeholder:tw-font-normal tw-w-full filter-dropdown`}
                              scrollHeight="200px" // Set a height for scrolling
                              filterBy="projectKey,name"
                              filter
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="jobno tw-mt-2">
                          <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                            <label htmlFor="JobNo" className="tw-mt-3">
                              Job No
                            </label>
                            <InputText
                              type="text"
                              className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid ${
                                formErrors.jobNoMapping
                                  ? "tw-border-red-600"
                                  : "tw-border-gray-300"
                              } tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                              placeholder="Enter job No"
                              id="jobno"
                              aria-describedby="jobNoMapping-no-help"
                              value={formValues?.jobNoMapping ?? ""}
                              disabled={isInvoicePresent && !isEdit}
                              invalid={!!formErrors.jobNoMapping}
                            />
                          </div>
                        </div>
                      )} */}
                      <div className="jobno tw-mt-2">
                        <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                          <label
                            htmlFor="JobNo"
                            className="tw-mt-3 tw-font-semibold"
                          >
                            Job No
                          </label>
                          {isFirstJobNumber &&
                          (formValues?.jobNoMapping?.length <= 1 ||
                            !invoiceParam) ? (
                            <>
                              {formValues?.jobNumber &&
                              !isEdit &&
                              !invoiceDetailsLoading ? (
                                <>
                                  <InputText
                                    type="text"
                                    className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid ${
                                      formErrors.jobNoMapping
                                        ? "tw-border-red-600"
                                        : "tw-border-gray-300"
                                    } tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                                    placeholder="Enter job No"
                                    id="jobno"
                                    aria-describedby="jobNoMapping-no-help"
                                    value={
                                      formValues?.jobNoMapping.length === 0
                                        ? formValues?.jobNumber ?? ""
                                        : `${
                                            allProjects.find(
                                              (project) =>
                                                project.projectID ===
                                                formValues?.jobNoMapping[0]
                                                  ?.jobNumber
                                            )?.projectKey
                                          } - ${
                                            allProjects.find(
                                              (project) =>
                                                project.projectID ===
                                                formValues?.jobNoMapping[0]
                                                  ?.jobNumber
                                            )?.name
                                          }`
                                    }
                                    disabled={isInvoicePresent && !isEdit}
                                    // invalid={!!formErrors.jobNoMapping}
                                  />
                                </>
                              ) : (
                                <div className="tw-flex tw-flex-col tw-w-full tw-items-end">
                                  <Dropdown
                                    className={`tw-w-full tw-h-10 tw-border tw-rounded-md tw-shadow-sm filter-dropdown ${
                                      formErrors?.jobNoMapping
                                        ? "tw-border-red-500"
                                        : "tw-border-gray-300"
                                    }`}
                                    value={
                                      isResetForm
                                        ? null
                                        : tempJobEntries.length === 0 &&
                                          formValues?.jobNumber
                                        ? allProjects.find(
                                            (project) =>
                                              project.projectKey ===
                                              formValues?.jobNumber.split(
                                                " - "
                                              )[0]
                                          )
                                        : allProjects.find(
                                            (project: any) =>
                                              project.projectID ===
                                              tempJobEntries[0].jobNumber
                                          )
                                    }
                                    // disabled={isEditMode === false}
                                    options={allProjects}
                                    disabled={isInvoicePresent && !isEdit}
                                    itemTemplate={jobNumberOptionsTemplate}
                                    valueTemplate={jobNumberValueTemplate}
                                    onChange={(e) =>
                                      handleJobNumberChange(0, e.value)
                                    }
                                    placeholder="Select Job Number"
                                    onClick={(e) => e.stopPropagation()}
                                    onKeyDown={(e) => {
                                      if (
                                        e.key === " " ||
                                        e.key === "Enter" ||
                                        e.key === "ArrowUp" ||
                                        e.key === "ArrowDown"
                                      ) {
                                        e.stopPropagation();
                                      }
                                    }}
                                    filterBy="projectKey,name"
                                    filterMatchMode="contains"
                                    filter
                                  />
                                  {tempJobEntries &&
                                    tempJobEntries.length !== 0 &&
                                    tempJobEntries[0].jobNumber !== "" &&
                                    !(isInvoicePresent && !isEdit) && (
                                      <Button
                                        label="Add"
                                        onClick={() =>
                                          setShowAddJobNumber(true)
                                        }
                                        disabled={invoiceDetailsLoading}
                                        className={`tw-border-gray-700 tw-border tw-border-solid tw-text-[#3d3d3d]  tw-w-fit tw-px-2 tw-py-1 tw-text-sm tw-font-semibold focus:tw-shadow-none tw-mt-2  `}
                                        // className="tw-text-blue-500 tw-text-sm tw-font-semibold"
                                        text
                                      />
                                    )}
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="tw-flex tw-gap-2 tw-items-center">
                              {formValues?.totalAmount ? (
                                <Button
                                  label={`${
                                    !invoiceParam
                                      ? "Add"
                                      : isEdit
                                      ? "Update"
                                      : "View"
                                  } Job No`}
                                  onClick={() => setShowAddJobNumber(true)}
                                  disabled={invoiceDetailsLoading}
                                  className={` ${
                                    formErrors.jobNoMapping
                                      ? "tw-border-red-600 tw-text-red-600"
                                      : "tw-border-gray-300 tw-text-blue-500"
                                  } tw-border-gray-700 tw-border tw-border-solid  tw-w-fit tw-px-2 tw-py-1 tw-text-sm tw-font-semibold focus:tw-shadow-none tw-mt-2`}
                                  // className="tw-text-blue-500 tw-text-sm tw-font-semibold"
                                  text
                                />
                              ) : (
                                <InputText
                                  type="text"
                                  className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid ${
                                    formErrors.jobNoMapping
                                      ? "tw-border-red-600"
                                      : "tw-border-gray-300"
                                  } tw-rounded-md tw-h-11 placeholder:tw-font-normal tw-border-r`}
                                  placeholder="Job No"
                                  id="jobno"
                                  readOnly
                                  aria-describedby="jobNoMapping-no-help"
                                  value={""}
                                  disabled={isInvoicePresent && !isEdit}
                                  // invalid={!!formErrors.jobNoMapping}
                                />
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="manager tw-mt-2">
                        <div className="tw-flex tw-flex-col tw-gap-2">
                          <label
                            htmlFor="manager"
                            className="tw-mt-3 tw-font-semibold"
                          >
                            Manager
                          </label>
                          <Dropdown
                            id="Manager"
                            value={formValues?.selectedManager ?? {}}
                            onChange={(e) => {
                              setFormErrors((prevErrors) => ({
                                ...prevErrors,
                                managerID: null,
                              }));
                              handleInputChange(
                                "selectedManager",
                                e.target.value
                              );
                            }} // Store selected manager
                            options={managers} // Pass managers to Dropdown
                            optionLabel="displayName" // Display manager names
                            placeholder="Select Manager"
                            valueTemplate={managerValueTemplate}
                            // filter
                            disabled={isInvoicePresent && !isEdit}
                            className={`tw-h-11 tw-border tw-border-solid ${
                              formErrors.managerID
                                ? "tw-border-red-600"
                                : "tw-border-gray-300"
                            } tw-rounded-md placeholder:tw-font-normal tw-w-full filter-dropdown`}
                            scrollHeight="200px" // Set a height for scrolling
                            filter
                          />
                        </div>
                      </div>
                      <div className="senior-manager tw-mt-2">
                        <div className="tw-flex tw-flex-col tw-gap-2">
                          <label
                            htmlFor="senior-manager"
                            className="tw-mt-3 tw-font-semibold"
                          >
                            Senior Manager
                          </label>
                          <Dropdown
                            id="SeniorManager"
                            value={formValues?.selectedSeniorManager ?? {}}
                            onChange={(e) => {
                              setFormErrors((prevErrors) => ({
                                ...prevErrors,
                                seniorManagerID: null,
                              }));
                              handleInputChange(
                                "selectedSeniorManager",
                                e.target.value
                              );
                            }}
                            options={seniorManagers}
                            optionLabel="displayName"
                            placeholder="Select Senior Manager"
                            valueTemplate={seniorManagerValueTemplate}
                            disabled={isInvoicePresent && !isEdit}
                            className={`tw-h-11 tw-border tw-border-solid ${
                              formErrors.seniorManagerID
                                ? "tw-border-red-600"
                                : "tw-border-gray-300"
                            } tw-rounded-md placeholder:tw-font-normal tw-w-full filter-dropdown`}
                            scrollHeight="200px"
                            filter
                          />
                        </div>
                      </div>
                      <div className="director tw-mt-2">
                        <div className="tw-flex tw-flex-col tw-gap-2">
                          <div className="tw-flex tw-justify-between">
                            <label
                              htmlFor="director"
                              className="tw-mt-3 tw-font-semibold"
                            >
                              Director
                            </label>
                            {((formValues?.selectedDirector &&
                              formValues?.selectedDirector?.userEmail !==
                                CATHERINE_O_NEILL.userEmail &&
                              !invoiceParam) ||
                              (selectedDirectorEmail &&
                                isEdit &&
                                selectedDirectorEmail !==
                                  CATHERINE_O_NEILL.userEmail) ||
                              (!isEdit && isFinalApproval) ||
                              (selectedDirectorEmail &&
                                isEdit &&
                                formValues?.selectedDirector?.userEmail &&
                                formValues?.selectedDirector?.userEmail !==
                                  CATHERINE_O_NEILL.userEmail)) && (
                              <div
                                className={`tw-mt-3  ${
                                  isInvoicePresent &&
                                  isEdit &&
                                  localStorage.userID.toString() !==
                                    formValues?.createdByID?.toString() &&
                                  "tw-text-gray-400"
                                }`}
                              >
                                <Checkbox
                                  inputId="terms"
                                  checked={isFinalApproval}
                                  onChange={(e) => {
                                    setIsFinalApproval(e.checked);
                                    setFormValues((prevFormValues: any) => ({
                                      ...prevFormValues,
                                      finalApproval: e.checked,
                                    }));
                                  }}
                                  className="tw-mr-2 tw-border tw-rounded-md"
                                  disabled={
                                    (isInvoicePresent && !isEdit) ||
                                    (isInvoicePresent &&
                                      isEdit &&
                                      localStorage.userID.toString() !==
                                        formValues?.createdByID?.toString()) ||
                                    // (selectedInvoice && invoiceParam &&
                                    //   !invoiceDetailsLoading &&
                                    //   // selectedInvoice?.finalApproval &&
                                    //   selectedInvoice?.status ===
                                    //     STATUSES.FINAL_APPROVAL_PENDING) ||
                                    // (selectedInvoice && invoiceParam &&
                                    //   !invoiceDetailsLoading &&
                                    //   selectedInvoice?.status ===
                                    //     STATUSES.APPROVED_BY_DIRECTOR) ||
                                    // (selectedInvoice && invoiceParam &&
                                    //   !invoiceDetailsLoading &&
                                    //   selectedInvoice?.status ===
                                    //     STATUSES.ENTERED)
                                    (selectedInvoice &&
                                      invoiceParam &&
                                      formValues?.selectedDirector
                                        ?.userEmail ===
                                        selectedInvoice?.directorEmail &&
                                      !invoiceDetailsLoading &&
                                      (selectedInvoice?.status ===
                                        STATUSES.FINAL_APPROVAL_PENDING ||
                                        selectedInvoice?.status ===
                                          STATUSES.APPROVED_BY_DIRECTOR ||
                                        selectedInvoice?.status ===
                                          STATUSES.ENTERED))
                                  }
                                />
                                <label className="tw-font-semibold">
                                  Final Approval?
                                </label>
                              </div>
                            )}
                          </div>
                          <Dropdown
                            value={formValues?.selectedDirector ?? {}}
                            onChange={(e) => {
                              setFormErrors((prevErrors) => ({
                                ...prevErrors,
                                directorID: null,
                              }));
                              if (invoiceParam) {
                                selectedInvoice?.directorEmail ===
                                  e.target.value.userEmail &&
                                  setIsFinalApproval(
                                    selectedInvoice?.finalApproval ?? false
                                  );
                                setFormValues((prevFormValues: any) => ({
                                  ...prevFormValues,
                                  finalApproval: selectedInvoice?.finalApproval,
                                }));
                              }
                              setSelectedDirectorEmail(
                                e.target.value.userEmail
                              );
                              if (
                                e.target.value.userEmail ===
                                CATHERINE_O_NEILL.userEmail
                              ) {
                                setIsFinalApproval(false);
                                setFormValues((prevFormValues: any) => ({
                                  ...prevFormValues,
                                  finalApproval: false,
                                }));
                              }
                              handleInputChange(
                                "selectedDirector",
                                e.target.value
                              );
                            }} // Store selected director
                            options={directors} // Pass directors to Dropdown
                            optionLabel="displayName" // Display director names
                            placeholder="Select Director"
                            valueTemplate={directorValueTemplate}
                            disabled={isInvoicePresent && !isEdit}
                            className={`tw-h-11 tw-border tw-border-solid ${
                              formErrors.directorID
                                ? "tw-border-red-600"
                                : "tw-border-gray-300"
                            } tw-rounded-md placeholder:tw-font-normal tw-w-full filter-dropdown`}
                            filter
                          />
                        </div>
                      </div>
                      <div className="pono tw-mt-2">
                        <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                          <label
                            htmlFor="PONo"
                            className="tw-mt-3 tw-font-semibold"
                          >
                            PO No
                          </label>
                          <InputText
                            type="text"
                            className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid ${
                              formErrors.poNumber
                                ? "tw-border-red-600"
                                : "tw-border-gray-300"
                            } tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                            placeholder="Enter PO No"
                            id="PONo"
                            aria-describedby="po-no-help"
                            value={formValues?.poNumber ?? ""}
                            disabled={isInvoicePresent && !isEdit}
                            onChange={(e) => {
                              setFormErrors((prevErrors) => ({
                                ...prevErrors,
                                poNumber: null,
                              }));
                              handleInputChange("poNumber", e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="company tw-mt-2">
                        <div className="tw-flex tw-flex-col tw-gap-2">
                          <label
                            htmlFor="SupplierName"
                            className="tw-mt-3 tw-font-semibold"
                          >
                            Company
                          </label>
                          <Dropdown
                            value={formValues?.selectedCompany ?? {}}
                            onChange={(e) => {
                              setFormErrors((prevErrors) => ({
                                ...prevErrors,
                                companyID: null,
                              }));
                              handleInputChange(
                                "selectedCompany",
                                e.target.value
                              );
                            }} // Store selected company
                            options={
                              companies?.map((company) => ({
                                label: company.companyName, // Displayed text
                                value: company.companyID, // Underlying value
                              })) || []
                            } // Fallback to an empty array if companies is null
                            optionLabel="label" // Display company names
                            placeholder="Select Company"
                            className={`tw-h-11 tw-border tw-border-solid ${
                              formErrors.companyID
                                ? "tw-border-red-600"
                                : "tw-border-gray-300"
                            } tw-rounded-md placeholder:tw-font-normal tw-w-full filter-dropdown`}
                            disabled={isInvoicePresent && !isEdit}
                          />
                        </div>
                      </div>
                      <div className="adminnotes tw-mt-2">
                        <div className="tw-flex tw-flex-col tw-gap-2">
                          <label
                            htmlFor="AdminNotes"
                            className="tw-mt-3 tw-font-semibold"
                          >
                            Admin Notes
                          </label>
                          <InputText
                            type="text"
                            className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                            placeholder="Enter Admin Notes"
                            id="AdminNotes"
                            aria-describedby="Admin-Notes-help"
                            disabled={isInvoicePresent && !isEdit}
                            value={formValues?.commentBySuperAdmin ?? ""}
                            onChange={(e) =>
                              handleInputChange(
                                "commentBySuperAdmin",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                      {isInvoicePresent &&
                      selectedInvoice?.commentByManager != null ? (
                        <div className="managernotes">
                          <div
                            className={`tw-flex tw-flex-col tw-gap-2 tw-border tw-border-gray-300 tw-rounded-md tw-mt-2 tw-pt-0 tw-pr-4 tw-pb-2 tw-pl-4`}
                          >
                            <label
                              htmlFor="ManagerNotes"
                              className="tw-mt-1 tw-ml-[-10px] tw-font-semibold"
                            >
                              Manager Notes:-
                            </label>
                            <div
                              className={`${
                                isEdit ? "" : "tw-text-gray-400"
                              } tw-cursor-default`}
                            >
                              <div>
                                <strong>Job Number:</strong>{" "}
                                {parseComment(formValues?.commentByManager)
                                  .confirmJobNumber?.length > 200 ? (
                                  <>
                                    <Tooltip
                                      target=".job-number-tooltip"
                                      mouseTrack
                                      mouseTrackLeft={10}
                                    />
                                    <span
                                      className="job-number-tooltip"
                                      data-pr-tooltip={
                                        parseComment(
                                          formValues?.commentByManager
                                        ).confirmJobNumber
                                      }
                                    >
                                      {parseComment(
                                        formValues?.commentByManager
                                      ).confirmJobNumber.substring(0, 200)}
                                      ...
                                    </span>
                                  </>
                                ) : (
                                  // </span>
                                  parseComment(formValues?.commentByManager)
                                    .confirmJobNumber
                                )}
                              </div>
                              <div>
                                <strong>Site Name:</strong>{" "}
                                {
                                  parseComment(formValues?.commentByManager)
                                    .confirmSiteName
                                }
                              </div>
                              <div>
                                <strong>Comment:</strong>{" "}
                                {
                                  parseComment(formValues?.commentByManager)
                                    .comment
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {isInvoicePresent &&
                      selectedInvoice?.commentBySeniorManager != null ? (
                        <div className="seniormanagernotes">
                          <div
                            className={`tw-flex tw-flex-col tw-gap-2 tw-border tw-border-gray-300 tw-rounded-md tw-mt-2 tw-pt-0 tw-pr-4 tw-pb-2 tw-pl-4`}
                          >
                            <label
                              htmlFor="SeniorManagerNotes"
                              className="tw-mt-1 tw-ml-[-10px] tw-font-semibold"
                            >
                              Senior Manager Notes:-
                            </label>
                            <div
                              className={`${
                                isEdit ? "" : "tw-text-gray-400"
                              } tw-cursor-default`}
                            >
                              <div>
                                <strong>Job Number:</strong>{" "}
                                {parseComment(
                                  formValues?.commentBySeniorManager
                                ).confirmJobNumber?.length > 200 ? (
                                  <>
                                    <Tooltip
                                      target=".senior-manager-job-number-tooltip"
                                      mouseTrack
                                      mouseTrackLeft={10}
                                    />
                                    <span
                                      className="senior-manager-job-number-tooltip"
                                      data-pr-tooltip={
                                        parseComment(
                                          formValues?.commentBySeniorManager
                                        ).confirmJobNumber
                                      }
                                    >
                                      {parseComment(
                                        formValues?.commentBySeniorManager
                                      ).confirmJobNumber.substring(0, 200)}
                                      ...
                                    </span>
                                  </>
                                ) : (
                                  parseComment(
                                    formValues?.commentBySeniorManager
                                  ).confirmJobNumber
                                )}
                              </div>
                              <div>
                                <strong>Site Name:</strong>{" "}
                                {
                                  parseComment(
                                    formValues?.commentBySeniorManager
                                  ).confirmSiteName
                                }
                              </div>
                              <div>
                                <strong>Comment:</strong>{" "}
                                {
                                  parseComment(
                                    formValues?.commentBySeniorManager
                                  ).comment
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {isInvoicePresent &&
                      selectedInvoice?.commentByDirector != null ? (
                        <div className="directornotes">
                          <div className="tw-flex tw-flex-col tw-gap-2">
                            <label
                              htmlFor="DirectorNotes"
                              className="tw-mt-3 tw-font-semibold"
                            >
                              Director Notes
                            </label>
                            <InputText
                              type="text"
                              className={`${
                                isEdit ? "" : "tw-text-gray-400"
                              } tw-cursor-default tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300} tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                              placeholder="Enter Director Notes"
                              id="DirectorNotes"
                              aria-describedby="Director-Notes-help"
                              readOnly={true}
                              value={formValues?.commentByDirector ?? ""}
                              onChange={(e) =>
                                handleInputChange(
                                  "commentByDirector",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>

                <div
                  className={`card-footer tw-justify-end tw-items-center tw-gap-4`}
                >
                  {isInvoicePresent || invoiceParam ? null : (
                    <>
                      <div className="tw-flex tw-justify-end tw-items-center tw-gap-4">
                        <Button
                          type="button"
                          className="tw-rounded-md tw-bg-[#555555] tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-[#555555] focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-[#555555]"
                          onClick={() => resetForm("resetButtonClick")}
                        >
                          Reset
                        </Button>
                        <Button
                          type="button"
                          disabled={fileUploading}
                          onClick={handleSubmit}
                          className="tw-rounded-md tw-bg-sky-500 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-sky-400 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-sky-500"
                        >
                          Send For Approvals
                        </Button>
                      </div>
                    </>
                  )}
                  {isEdit && invoiceParam ? (
                    <Button
                      type="button"
                      onClick={handleUpdate}
                      disabled={!isEdit || fileUploading}
                      className={`tw-rounded-md tw-bg-sky-500 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm  focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-sky-500`}
                    >
                      {fileUploading ? "Updating..." : "Update"}
                    </Button>
                  ) : null}
                  {selectedInvoice?.statusID &&
                  !isEdit && // Check if selectedInvoice and statusID exist
                  ((localStorage.roleName.includes(ROLES.MANAGER) &&
                    selectedInvoice.statusID === 1 &&
                    selectedInvoice?.managerID.toString() ===
                      localStorage.userID.toString()) ||
                    (localStorage.roleName.includes(ROLES.SENIOR_MANAGER) &&
                      selectedInvoice.statusID === 2 &&
                      selectedInvoice?.seniorManagerID.toString() ===
                        localStorage.userID.toString()) ||
                    (localStorage.roleName.includes(ROLES.DIRECTOR) &&
                      selectedInvoice.statusID === 9 &&
                      selectedInvoice?.directorID.toString() ===
                        localStorage.userID.toString()) ||
                    (localStorage.userEmail === CATHERINE_O_NEILL.userEmail &&
                      selectedInvoice.statusID === 8 &&
                      formValues?.finalApproval)) ? (
                    <>
                      <Button
                        type="button"
                        onClick={handleReject}
                        className="tw-rounded-md tw-bg-[#555555] tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-[#555555] focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-sky-500"
                      >
                        Reject
                      </Button>
                      <Button
                        type="button"
                        className="tw-rounded-md tw-bg-[#00AFEE] tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-[#00AFEE] focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-[#555555]"
                        onClick={handleApprove}
                      >
                        Approve
                      </Button>
                    </>
                  ) : null}
                  {selectedInvoice?.statusID &&
                  (localStorage.roleName.includes(ROLES.SUPER_ADMIN) ||
                    localStorage.roleName.includes(ROLES.ACCOUNTANT)) &&
                  !isEdit &&
                  selectedInvoice.statusID === 4 &&
                  invoiceParam ? (
                    <Button
                      type="button"
                      className="tw-rounded-md tw-bg-[#00AFEE] tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-[#00AFEE] focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-[#555555]"
                      onClick={() => setIsConfirmEntryDialogOpen(true)}
                    >
                      Entry
                    </Button>
                  ) : null}
                </div>
              </TabPanel>

              {invoiceParam ? (
                <TabPanel header="Activity">
                  <Timeline
                    align="left"
                    marker={customizedMarker}
                    content={customizedContent}
                    value={events}
                  />
                </TabPanel>
              ) : null}
            </TabView>
          </div>
        </div>
        <div className="invoice-preview tw-h-full a-card">
          <div className="pdf-viewer tw-h-full a-card tw-flex tw-flex-col tw-w-full">
            <div className="card-header tw-flex tw-justify-between tw-items-center">
              <h2 className="card-title">
                {invoiceParam
                  ? cancelFileOnEdit
                    ? "Replace"
                    : "View"
                  : "Upload"}{" "}
                Invoice
              </h2>
              <button
                type="button"
                className="tw-rounded-md tw-bg-sky-500 tw-px-2 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-sky-400 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-sky-500"
                onClick={() => navigate("/layout/invoice-management")}
              >
                <FeatherIcon icon="x" />
              </button>
            </div>

            <div
              className={`${
                isInvoicePresent ? "" : "tw-flex tw-mt-0"
              } tw-relative tw-items-center tw-justify-center tw-w-full`}
            >
              {(isInvoicePresent && !cancelFileOnEdit) || isAddInvoice ? (
                <FileViewer
                  type={
                    isAddInvoice && !isInvoicePresent
                      ? "addInvoice"
                      : "updateInvoice"
                  }
                  fileUrl={viewFile}
                  isEdit={isEdit}
                  cancelFileOnEditBtn={cancelFileOnEditBtn}
                  onRemove={
                    localStorage.roleName.includes(ROLES.SUPER_ADMIN) ||
                    localStorage.roleName.includes(ROLES.ACCOUNTANT)
                      ? handleRemoveFunction
                      : null
                  }
                  file={uploadedFile}
                />
              ) : (
                <div
                  ref={drop}
                  className={`tw-w-full tw-h-[300px] tw-flex tw-justify-center tw-items-center tw-border tw-border-dashed tw-border-gray-300 ${
                    isOver ? "drag-over" : ""
                  }`}
                >
                  <FileUpload
                    name="demo[]"
                    url={`${process.env.REACT_APP_FILE_UPLOAD_URL}amelio/invoices/1727258344067~c4611_sample_explain.pdf`}
                    multiple
                    onSelect={(e) => setFiles(e.files)}
                    accept=".pdf"
                    chooseLabel="Click to upload"
                    maxFileSize={20972000}
                    className="tw-w-[100%]"
                    customUpload
                    uploadHandler={customBase64Uploader}
                    emptyTemplate={
                      <div className="import-button-template" id="emptyBlock">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="upload-cloud-02">
                            <path
                              id="Icon"
                              d="M6.66699 13.3333L10.0003 10M10.0003 10L13.3337 13.3333M10.0003 10V17.5M16.667 13.9524C17.6849 13.1117 18.3337 11.8399 18.3337 10.4167C18.3337 7.88536 16.2816 5.83333 13.7503 5.83333C13.5682 5.83333 13.3979 5.73833 13.3054 5.58145C12.2187 3.73736 10.2124 2.5 7.91699 2.5C4.46521 2.5 1.66699 5.29822 1.66699 8.75C1.66699 10.4718 2.3632 12.0309 3.48945 13.1613"
                              stroke="#475467"
                              strokeWidth="1.66667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </g>
                        </svg>
                        <div className="tw-flex tw-gap-2">
                          <span className="upload-link">Click to upload</span>
                          <span className="upload-text">or drag and drop</span>
                        </div>
                        <div className="tw-flex upload-text">
                          PDF single file max size 20MB
                        </div>
                      </div>
                    }
                    itemTemplate={(
                      inFile: object,
                      props: ItemTemplateOptions
                    ) => {
                      const originalFile = files[props.index];
                      const modifiedName = originalFile.name.replace(
                        /[^a-zA-Z0-9. ]/g,
                        ""
                      );
                      const file = new File([originalFile], modifiedName, {
                        type: originalFile.type,
                      });

                      inFile = new File([originalFile], modifiedName, {
                        type: originalFile.type,
                      });

                      const objectURL = URL.createObjectURL(file);
                      setIsFormModified(true);
                      setUploadedFile(file);
                      setIsAddInvoice(true);
                      setViewFile(objectURL);
                      return null;
                    }}
                  />
                </div>
              )}
            </div>

            <div className="card-footer tw-justify-center tw-items-center tw-gap-4 hide">
              <Button className="tw-rounded-full tw-bg-[#555555] tw-px-3 tw-py-3 tw-text-white tw-shadow-sm">
                <FeatherIcon icon="chevron-left" />
              </Button>
              <span className="attechment-page-count">0 of 0</span>
              <Button className="tw-rounded-full tw-bg-[#555555] tw-px-3 tw-py-3 tw-text-white tw-shadow-sm">
                <FeatherIcon icon="chevron-right" />
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        header={`${
          commentType === "Approved" &&
          (localStorage.roleName.includes(ROLES.MANAGER) ||
            localStorage.roleName.includes(ROLES.SENIOR_MANAGER))
            ? "Confirm Job No And Site Name"
            : "Comments"
        }`}
        visible={approveRejectDialog}
        style={{ width: "20vw" }}
        onHide={() => {
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            confirmJobNo: null,
            confirmSiteName: null,
            comment: null,
          }));
          // setConfirmJobNo(null);
          setConfirmSiteName("");
          setApproveRejectComment("");
          setApproveRejectDialog(false);
        }}
      >
        <div className="tw-flex tw-flex-col">
          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            {(localStorage.roleName.includes(ROLES.MANAGER) ||
              localStorage.roleName.includes(ROLES.SENIOR_MANAGER)) &&
              commentType === "Approved" && (
                <div>
                  <div className="tw-mt-0 tw-flex tw-flex-col tw-gap-2">
                    <label className=" tw-font-semibold">Job No.</label>
                    {/* <InputText
                      value={confirmJobNo ?? ""}
                      className={` ${
                        formErrors.confirmJobNo
                          ? "tw-border-red-600"
                          : "tw-border-gray-300"
                      } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                      onChange={(e) => {
                        setFormErrors((prevErrors) => ({
                          ...prevErrors,
                          confirmJobNo: null,
                        }));
                        setConfirmJobNo(e.target.value);
                      }}
                      placeholder="Confirm Job No."
                    /> */}
                    <div className="tw-flex tw-flex-col tw-w-full tw-items-end">
                      <MultiSelect
                        className={`tw-border tw-border-solid ${
                          formErrors.confirmJobNo
                            ? "tw-border-red-600"
                            : "tw-border-gray-300"
                        } tw-rounded-md placeholder:tw-font-normal tw-w-full`}
                        value={confirmJobNo ?? []}
                        selectAllLabel="Select All"
                        maxSelectedLabels={1}
                        options={[
                          ...confirmJobNo.map((selected: any) =>
                            allProjects.find(
                              (project) =>
                                project.projectID === selected.projectID
                            )
                          ),
                          ...allProjects.filter(
                            (project) =>
                              !confirmJobNo.some(
                                (selected: any) =>
                                  selected.projectID === project.projectID
                              )
                          ),
                        ]}
                        itemTemplate={jobNumberOptionsTemplate}
                        selectedItemTemplate={jobNumberValueTemplate}
                        onChange={(e) => {
                          setFormErrors((prevErrors) => ({
                            ...prevErrors,
                            confirmJobNo: null,
                          }));
                          setConfirmJobNo(e.value);
                        }}
                        placeholder="Select Job Number"
                        onClick={(e) => e.stopPropagation()}
                        onKeyDown={(e) => {
                          if (
                            e.key === " " ||
                            e.key === "Enter" ||
                            e.key === "ArrowUp" ||
                            e.key === "ArrowDown"
                          ) {
                            e.stopPropagation();
                          }
                        }}
                        filterBy="projectKey,name"
                        filterMatchMode="contains"
                        filter
                      />
                    </div>
                    {formErrors.confirmJobNo && (
                      <p className="tw-text-red-600">
                        {formErrors.confirmJobNo}
                      </p>
                    )}
                  </div>
                  <div className="tw-mt-2 tw-flex tw-flex-col tw-gap-2">
                    <label className=" tw-font-semibold">Site Name</label>
                    <InputText
                      value={confirmSiteName ?? ""}
                      className={`${
                        formErrors.confirmSiteName
                          ? "tw-border-red-600"
                          : "tw-border-gray-300"
                      } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                      onChange={(e) => {
                        setFormErrors((prevErrors) => ({
                          ...prevErrors,
                          confirmSiteName: null,
                        }));
                        setConfirmSiteName(e.target.value);
                      }}
                      placeholder="Confirm Site Name"
                    />
                    {formErrors.confirmSiteName && (
                      <p className="tw-text-red-600">
                        {formErrors.confirmSiteName}
                      </p>
                    )}
                  </div>
                </div>
              )}
            <div className="tw-mt-0 tw-flex tw-flex-col tw-gap-2">
              <label className=" tw-font-semibold">Comments</label>
              <InputTextarea
                className={`${
                  formErrors.comment
                    ? "tw-border-red-600"
                    : "tw-border-gray-300"
                } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-rounded-md placeholder:tw-font-normal`}
                onChange={(e) => {
                  if (commentType === "Rejected") {
                    setFormErrors((prevErrors) => ({
                      ...prevErrors,
                      comment: null,
                    }));
                  }
                  setApproveRejectComment(e.target.value);
                }}
                placeholder="Comments"
              />
              {formErrors.comment && (
                <p className="tw-text-red-600">{formErrors.comment}</p>
              )}
            </div>
          </div>

          <Button
            label={`${commentType === "Approved" ? "Approve" : "Reject"}`}
            className={`tw-flex tw-px-3 tw-py-2 tw-rounded-lg ${
              commentType === "Approved" ? "" : "tw-bg-[#555555]"
            } bg-primary border-primary tw-text-white tw-font-medium tw-w-full tw-mt-8`}
            onClick={handleApproveReject}
            disabled={isApproveRejectButtonDisabled}
          />
        </div>
      </Dialog>
      <AddJobNumbers
        showAddJobNumber={showAddJobNumber}
        title={`${!invoiceParam ? "Add" : isEdit ? "Update" : "View"} Job No`}
        formValues={formValues}
        isEditMode={isEdit}
        invoiceParam={invoiceParam}
        rowData={invoiceParam ? formValues : []}
        setFormValues={setFormValues}
        currency={currency}
        allProjects={allProjects}
        newAllProjects={newAllProjects}
        isResetForm={isResetForm}
        setIsResetForm={setIsResetForm}
        onClose={() => {
          setTempJobEntries(newTempJobNumbers);
          setShowAddJobNumber(false);
        }}
        setShowAddJobNumber={setShowAddJobNumber}
        tempJobEntries={tempJobEntries}
        setTempJobEntries={setTempJobEntries}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
        handleJobNumberChange={handleJobNumberChange}
        handleAmountChange={handleAmountChange}
        newTempJobNumbers={newTempJobNumbers}
        setNewTempJobNumbers={setNewTempJobNumbers}
        tempValidationErrors={tempValidationErrors}
        setTempValidationErrors={setTempValidationErrors}
      />
    </>
  );
}

export default AddInvoice;
